/* Soulshine Gemstone — theme interactions (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- sticky header shadow ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile menu drawer ---------- */
  var drawer = document.querySelector('[data-menu-drawer]');
  var overlay = document.querySelector('[data-overlay]');
  function openDrawer() { if (drawer) drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- reveal on scroll ----------
     .reveal starts at opacity:0 and only becomes visible once observed. Two
     things must hold or sections render permanently blank:
       1. Sections added/reordered in the theme editor are injected after this
          script has already run, so they need re-observing on section:load.
       2. In the editor, merchants judge a section the instant they add it and
          won't scroll to trigger it — so show it immediately in design mode.
     A very tall element could also never hit a 0.12 threshold, so use 0 with
     a rootMargin instead of a ratio. */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
  }

  function initReveals(scope) {
    var inDesignMode = !!(window.Shopify && window.Shopify.designMode);
    (scope || document).querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      if (inDesignMode || !io) { el.classList.add('is-visible'); return; }
      io.observe(el);
    });
  }
  initReveals(document);

  /* Sections added or edited in the theme editor are injected after this
     script has run. Re-reveal just the new subtree. Deliberately scoped to
     reveals only: the other handlers below bind directly to elements, so
     re-running them wholesale would double-bind on every editor keystroke. */
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
  });

  /* ---------- accordions ---------- */
  document.querySelectorAll('.accordion__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var body = head.nextElementSibling;
      var open = body.style.maxHeight && body.style.maxHeight !== '0px';
      if (open) { body.style.maxHeight = '0px'; head.setAttribute('aria-expanded', 'false'); }
      else { body.style.maxHeight = body.scrollHeight + 'px'; head.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* ---------- product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main] img');
    gal.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) { main.src = btn.dataset.thumb; main.srcset = ''; }
        gal.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        val += (b.dataset.dir === 'up' ? 1 : -1);
        if (val < 1) val = 1;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- cart count helper ---------- */
  window.SoulshineCart = {
    refresh: function () {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
        }).catch(function () {});
    }
  };

  /* ---------- AJAX quick-add ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () {
        window.SoulshineCart.refresh();
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600); }
      }).catch(function () {
        if (btn) { btn.textContent = label; btn.disabled = false; }
        window.location.href = '/cart';
      });
  });
})();
